import { render, staticRenderFns } from "./gameStageBackviewRace.vue?vue&type=template&id=45e8645c&scoped=true&"
import script from "./gameStageBackviewRace.vue?vue&type=script&lang=js&"
export * from "./gameStageBackviewRace.vue?vue&type=script&lang=js&"
import style0 from "./gameStageBackviewRace.vue?vue&type=style&index=0&id=45e8645c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8645c",
  null
  
)

export default component.exports